export interface Teacher {
  id: number;
  name: string;
  role: string;
  image: string;
  facebook?: string;
  twitter?: string;
  email?: string;
  profile?: string;
}

export const teachers: Teacher[] = [

  //new
   {
    id: 1,
    name: "Nigel Facey",
    role: "Principal",
    image: "/images/teachers/ADMIN_Nigel_Facey.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },
   {
    id: 2,
    name: "SARAH BEVANS",
    role: "BUSINESS MANAGER",
    image: "/images/teachers/BUSINESS_MANAGER_SARAH_BEVANS.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },
  {
    id: 3,
    name: "ARLENE JOHNSON MCLEOD",
    role: "Vice Principal",
    image: "/images/teachers/VP_ARLENE_JOHNSON_MCLEOD.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },

  {
    id: 4,
    name: "MARJORIE MCDONALD",
    role: "Vice Principal",
    image: "/images/teachers/VP_MARJORIE_MCDONALD.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },

   {
    id: 5,
    name: "GLENALEE BROWN",
    role: "ELC",
    image: "/images/teachers/ELC_GLENALEE_BROWN.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },

  {
    id: 6,
    name: "kAI00952",
    role: "Cultural Advisor",
    image: "/images/teachers/KAI_one.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },

  {
    id: 7,
    name: "STACY ANN MCRAE DAWKINS",
    role: "HS",
    image: "/images/teachers/HS_STACY_ANN_MCRAE_DAWKINS.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },
  {
    id: 8,
    name: "ETHLYIN REEVES BODDEN",
    role: "HS",
    image: "/images/teachers/HS_ETHLYIN_REEVES_BODDEN.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },
  {
    id: 9,
    name: "EVADNE HARDING",
    role: "PS",
    image: "/images/teachers/PS_EVADNE_HARDING.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },

  {
    id: 10,
    name: "SIMONE BRANDON",
    role: "PS",
    image: "/images/teachers/PS_SIMONE_BRANDON.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },
  {
    id: 11,
    name: "KHAJIA CAMPBELL",
    role: "PS",
    image: "/images/teachers/PS_KHAJIA_CAMPBELL.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },
  {
    id: 12,
    name: "NICOLA BLACKMORE DAVY",
    role: "PS",
    image: "/images/teachers/PS_NICOLA_BLACKMORE_DAVY.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },
  {
    id: 13,
    name: "TAMARIE WILLIAMS",
    role: "PC",
    image: "/images/teachers/PC_TAMARIE_WILLIAMS.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },
  {
    id: 14,
    name: "ALANA Y.C.HARRY",
    role: "PS",
    image: "/images/teachers/PS_ALANA_Y_C_HARRY.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },
  {
    id: 15,
    name: "STACEY ANN McCUBBIN CLARKE",
    role: "PS",
    image: "/images/teachers/PS_STACEY_ANN_McCUBBIN_CLARKE.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },
  {
    id: 16,
    name: "BRIDGET DAWN PATTERSON",
    role: "SS",
    image: "/images/teachers/SS_BRIDGET_DAWN_PATTERSON.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },
   {
    id: 17,
    name: "ANGELA MCINTOSH HALL",
    role: "ELC",
    image: "/images/teachers/ELC_ANGELA_MCINTOSH_HALL.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },
  {
    id: 18,
    name: "MARLENE HARRY",
    role: "ADMIN SECRETARY",
    image: "/images/teachers/ADMIN_SECRETARY_MARLENE_HARRY.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },

 
  {
    id: 19,
    name: "SHANICE THOMAS",
    role: "ELC",
    image: "/images/teachers/ELC_SHANICE_THOMAS.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },

  {
    id: 20,
    name: "NICOLE WATLER",
    role: "ACCOUNTANT",
    image: "/images/teachers/ACCOUNTANT_NICOLE_WATLER.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },

  {
    id: 21,
    name: "SHANNA TUN BROOMFIELD",
    role: "HS",
    image: "/images/teachers/HS_SHANNA_TUN_BROOMFIELD.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },

  {
    id: 22,
    name: "SHIRLETTE FACEY",
    role: "HS",
    image: "/images/teachers/HS_SHIRLETTE_FACEY.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },

  {
    id: 23,
    name: "DANE BAILEY",
    role: "HS",
    image: "/images/teachers/HS_DANE_BAILEY.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },

  {
    id: 24,
    name: "DEXTER WILLIAMS",
    role: "HS",
    image: "/images/teachers/HS_DEXTER_WILLIAMS.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },

  {
    id: 25,
    name: "JULLISA SALMON",
    role: "HS",
    image: "/images/teachers/HS_JULLISA_SALMON.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },

  {
    id: 26,
    name: "LINTON PATTERSON",
    role: "HS",
    image: "/images/teachers/HS_LINTON_PATTERSON.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },

  {
    id: 27,
    name: "PETELLEE JONES",
    role: "HS",
    image: "/images/teachers/HS_PETELLEE_JONES.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },

  {
    id: 28,
    name: "ROSETTE WALTERS",
    role: "HS",
    image: "/images/teachers/HS_ROSETTE_WALTERS.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },

  {
    id: 29,
    name: "KAI00045",
    role: "Cultural Advisor",
    image: "/images/teachers/KAI00045.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },

  {
    id: 30,
    name: "KAI00292",
    role: "Cultural Advisor",
    image: "/images/teachers/KAI00292.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },

  

  {
    id: 31,
    name: "FRANCE CHAMBERS",
    role: "CP",
    image: "/images/teachers/CP_FRANCE_CHAMBERS.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },

  {
    id: 32,
    name: "KHARIM SAMUELS",
    role: "DD",
    image: "/images/teachers/DD_KHARIM_SAMUELS.webp",
    facebook: "https://www.facebook.com/login/",
    twitter: "https://twitter.com/i/flow/login",
    email: "/contact",
    profile: "/about",
  },
];
